// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__12AH4","buttons":"PendingPaymentAlert_buttons__2fxe5"};